import React from 'react';
import { Input, FormGroup, Col, Label } from 'reactstrap';
import T from 'i18n-react';

const Expiry = ({onChangedMonth, onChangedYear, error, value}) => (
    <FormGroup row>
        <Label for="expiry" sm={4}>
          <T.text tag='span' text="expire"/>
        </Label>
        <Col sm={4}>
            <Label for="month" className="exp-label">
              <T.text tag='span' text="month"/>
            </Label>
            <Input type="text" value = {value.month} name="month" className={(error.errorMonth ? 'form-control inp-month highlight-error' : 'form-control inp-month')} onChange={onChangedMonth} />
            {error.errorMonth &&  <p className="text-danger errorDate">{error.errorMonth}</p>}
        </Col>
        <Col sm={4} >
            <Label for="year" className="exp-label">
              <T.text tag='span' text="year"/>
            </Label>
            <Input type="text" value = {value.year} name="year" className={(error.errorYear ? 'form-control inp-year highlight-error' : 'form-control inp-year')} onChange={onChangedYear} />
            {error.errorYear &&  <p className="text-danger errorDate">{error.errorYear}</p>}
        </Col>
    </FormGroup>
);
export default Expiry;



// WEBPACK FOOTER //
// ./src/components/creditCard/Expiry.js